const headersFatura = [
  { text: "Fatura", value: "numero", class: "px-2" },
  {
    text: "Emissão",
    value: "emissao",
    sortable: false,
    class: "px-2",
    width: 100
  },
  {
    text: "Vencimento",
    value: "vencimento",
    sortable: false,
    class: "px-2",
    width: 100
  },
  { text: "Saldo", value: "saldo", sortable: false, class: "px-2" },
  {
    text: "Descricao",
    value: "nomeSacado",
    sortable: false,
    class: "px-2"
  },
  { text: "Imposto", value: "imposto", sortable: false, class: "px-2" },
  { text: "Juros", value: "juros", sortable: false, class: "px-2" },
  { text: "Multa", value: "multa", sortable: false, class: "px-2" }
];

const headersParcelas = [
  { text: "Nota Recebimento", value: "notaRecebimento", class: "px-2" },
  {
    text: "Parcela",
    value: "numeroParcela",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Vencimento",
    value: "vencimento",
    sortable: false,
    class: "px-2",
    width: 100
  },
  {
    text: "% Juros",
    value: "percentualJuros",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Juros Parcela",
    value: "valorJuros",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Imposto",
    value: "valorImpostos",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Valor Líquido",
    value: "valorLiquido",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Juros Atraso",
    value: "valorJurosDetalhe",
    sortable: false,
    class: "px-2"
  },
  {
    text: "% Multa",
    value: "percentualMulta",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Multa Atraso",
    value: "valorMultaDetalhe",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Valor Parcela",
    value: "valorParcela",
    sortable: false,
    class: "px-2"
  },
  { text: "Fatura", value: "linkBoleto", sortable: false, class: "px-2" }
];

const headersDetalhes = [
  { text: "Carteirinha", value: "cartaoBeneficiario", class: "px-2" },
  {
    text: "Beneficiário",
    value: "nomeBeneficiario",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Valor Original",
    value: "valorOriginal",
    sortable: false,
    class: "px-2"
  },
  {
    text: "Valor Parcela",
    value: "valorParcela",
    sortable: false,
    class: "px-2"
  },
  { text: "Juros", value: "valorJuros", sortable: false, class: "px-2" },
  { text: "Multa", value: "valorMulta", sortable: false, class: "px-2" },
  {
    text: "Valor Final",
    value: "valorFinal",
    sortable: false,
    class: "px-2"
  }
];

export { headersFatura, headersParcelas, headersDetalhes };
